'use client'

import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react'
import type { ReactNode } from 'react'

interface ModalProps {
  open: boolean
  onClose: (open: boolean) => void
  title?: ReactNode
  children: ReactNode
}

export default function Modal({ open, onClose, title, children }: ModalProps) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in fixed inset-0 bg-gray-900/70 transition-opacity"
      />

      <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 sm:p-6">
          <DialogPanel
            transition
            className="data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in data-closed:sm:translate-y-0 data-closed:sm:scale-95 relative w-full max-w-5xl transform overflow-hidden rounded-2xl bg-white text-left shadow-xl outline -outline-offset-1 outline-black/5 transition-all dark:bg-neutral-950 dark:outline-white/10"
          >
            <button
              type="button"
              onClick={() => {
                onClose(false)
              }}
              className="absolute right-3 top-3 z-10 inline-flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-black/5 text-neutral-700 hover:bg-black/10 dark:bg-white/10 dark:text-neutral-200 dark:hover:bg-white/15"
              aria-label="Close dialog"
            >
              <span aria-hidden="true">
                <FontAwesomeIcon icon={faXmark} />
              </span>
            </button>

            {title ? (
              <div className="px-4 pb-3 pt-4 sm:px-6 sm:pt-6">
                <DialogTitle
                  as="h3"
                  className="text-sm font-semibold tracking-tight text-neutral-900 dark:text-neutral-50"
                >
                  {title}
                </DialogTitle>
              </div>
            ) : null}

            <div className="p-4 sm:px-6 sm:pb-6">{children}</div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}
